import Vue from 'vue';
import TextSuggestionBlock from './TextSuggestionBlock';
import { SmartSuggestV4 } from '../../../../declarations/request';
import { InteractionBlockTypes } from '../../services/HandleInteractionService';

export default Vue.component('smart-suggest-suggestion', {
    template: `
    <smart-suggest-block-suggestion class="fl-as-suggestion" :icon="assets.iconSuggestion"
                                    :suggestions="textSuggestions" :block-name="config.blocks.suggest"
                                    v-on:submit="selectValue">
    </smart-suggest-block-suggestion>
  `,
    inject: ['config', 'HandleInteractionService', 'assets'],
    props: { textSuggestions: Array },
    components: {
        TextSuggestionBlock,
    },
    methods: {
        selectValue(textSuggestions: SmartSuggestV4.TextSuggestion): void {
            void this.HandleInteractionService.byBlock(InteractionBlockTypes.suggest).withValue(textSuggestions.text).trackAndSubmit();
        },
    },
});
